

/**
 * @class
 * @extend {import('./status-page.module').IStatusPageService}
 */
export class StatusPageService {

  /** @type {ng.IHttpService} */
  $http;

  /** type {string} */
  pageId;

  constructor(pageId, $http) {
    this.pageId = pageId;
    this.$http = $http;
  }

  /**
   * @returns {ng.IPromise<any>}
   */
  getIncidents() {
    return this.$http
      .get(`https://${this.pageId}.statuspage.io/api/v2/incidents/unresolved.json`)
      .then(_ => _.data?.incidents);
  }
}

export default StatusPageService;